/* eslint-disable react/prop-types */
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from 'src/features/tyre-management/components/ui/button';
import {
  Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from 'src/features/tyre-management/components/ui/dialog';
import { vehicleDetailsApi } from '../api/vehicleDetailsApi';
import useVehicleMutation from '../hooks/useVehicleMutation';

const VehicleStatusDialog = ({
  open, onOpenChange, vehicle, onSaved
}) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const nextActive = !vehicle?.active;
  const updateVehicleMutation = useVehicleMutation(
    vehicle?.id,
    (data) => vehicleDetailsApi.updateVehicle(vehicle.id, data)
  );

  const submit = async () => {
    setSaving(true);
    setError('');
    try {
      await updateVehicleMutation.mutateAsync({ active: nextActive });
      onOpenChange(false);
      onSaved();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {nextActive ? 'Activate' : 'Deactivate'}
            {' '}
            {vehicle?.registration_num}
          </DialogTitle>
          <DialogDescription>{nextActive ? 'The vehicle becomes available in active vehicle workflows.' : 'The vehicle remains in history but is removed from active vehicle workflows.'}</DialogDescription>
        </DialogHeader>
        <DialogBody>{error && <div className="rounded-lg bg-red-50 p-3 text-sm text-red-700" role="alert">{error}</div>}</DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant={nextActive ? 'default' : 'destructive'} onClick={submit} disabled={saving}>
            {saving && <Loader2 className="animate-spin" />}
            {nextActive ? 'Activate vehicle' : 'Deactivate vehicle'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VehicleStatusDialog;
